import { useQuery } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import { z } from 'zod/v4';
import { addResourceNameToQueryResult, useAxiosInstance } from './utils';
import type { ApiError } from './utils/types';

const DsoYearSchema = z.record(z.iso.datetime({ offset: true }), z.number().nullable());

export type DsoYear = z.infer<typeof DsoYearSchema>;

const DsoSchema = z.object({
  current_year: DsoYearSchema,
  previous_year: DsoYearSchema,
});

export type Dso = z.infer<typeof DsoSchema>;

async function loadDsoFn(axiosInstance: Promise<AxiosInstance>) {
  const instance = await axiosInstance;

  const { data } = await instance.get('/analytics/dsos', {
    params: { with_previous_year: true },
  });
  return DsoSchema.parse(data);
}

export function useLoadDso() {
  const axiosInstance = useAxiosInstance();

  const queryResult = useQuery<Dso, ApiError>({
    queryKey: ['dso'],
    queryFn: () => loadDsoFn(axiosInstance),
  });

  return addResourceNameToQueryResult<Dso, ApiError, 'dso'>('dso', queryResult);
}
